import defineApi from '../define-api'
import http from '../application-api'

export const getAbsentList = defineApi((config, params) => {
  config.params = params
  return http.load('/absent/list', config)
})

